/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organization_Signup_ErrorInputs */



/**
* | output |
* | --- |
* | "Organization signup failed. Please try again." |
*
* @param {Organization_Signup_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const organization_signup_error = /** @type {((inputs?: Organization_Signup_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organization_Signup_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler bei der Erstellung der Organisation. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Organization signup failed. Please try again.")
});